import { Modifier } from "@popperjs/core";
import { hasCheckMaxHeightModifierData } from "./checkMaxHeightModifier";

// Modifer to apply the styles from checkMaxHeightModifier.
export const applyMaxHeightModifier: Modifier<"applyMaxHeight", Record<string, never>> = {
    name: "applyMaxHeight" as const,
    enabled: true,
    phase: "main",
    requiresIfExists: ["offset", "preventOverflow", "checkMaxHeight"],
    fn({ state }) {
        if (
            hasCheckMaxHeightModifierData(state.modifiersData.checkMaxHeight) &&
            state.modifiersData.checkMaxHeight.height
        ) {
            state.elements.popper.style.maxHeight = state.modifiersData.checkMaxHeight.height - 16 + "px";
        }
    },
};
